export default function FeatureCards() {
  const features = [
    {
      title: "Kakobuy Shoes Spreadsheet",
      desc: "Najpopularniejsze sneakersy i obuwie sportowe w jednym miejscu. Znajdź najlepsze okazje na buty od sprawdzonych sprzedawców.",
      icon: "ri-footprint-line",
      image: "https://readdy.ai/api/search-image?query=Premium%20white%20and%20cream%20colored%20sneakers%20arranged%20on%20warm%20sand%20colored%20textured%20surface%2C%20soft%20natural%20window%20light%20from%20left%20creating%20gentle%20shadows%2C%20minimalist%20product%20photography%2C%20warm%20beige%20tones%2C%20clean%20ecommerce%20aesthetic%2C%20editorial%20footwear%20catalog%2C%20no%20branding%20visible%2C%20elegant%20simplicity&width=800&height=600&seq=kakobuy-feat-shoes-v2&orientation=landscape",
    },
    {
      title: "Kakobuy Hoodie Spreadsheet",
      desc: "Streetwear i moda — bluzy, swetry i odzież wierzchnia. Modne style w przystępnych cenach.",
      icon: "ri-shirt-line",
      image: "https://readdy.ai/api/search-image?query=Warm%20taupe%20colored%20oversized%20hoodie%20artfully%20draped%20on%20cream%20linen%20surface%2C%20soft%20morning%20daylight%20streaming%20through%20sheer%20curtain%2C%20minimalist%20fashion%20editorial%2C%20warm%20neutral%20earthy%20palette%2C%20texture%20detail%20visible%2C%20scandinavian%20clothing%20aesthetic%2C%20gentle%20shadows%2C%20premium%20catalog%20style&width=800&height=600&seq=kakobuy-feat-hoodie-v2&orientation=landscape",
    },
    {
      title: "Kakobuy Electronics Spreadsheet",
      desc: "Elektronika i gadżety — słuchawki, smartwatche i akcesoria technologiczne. Sprawdzone produkty w dobrych cenach.",
      icon: "ri-smartphone-line",
      image: "https://readdy.ai/api/search-image?query=Minimalist%20tech%20accessory%20flatlay%20with%20wireless%20earbuds%20case%20and%20sleek%20smartband%20on%20warm%20cream%20marble%20surface%2C%20soft%20natural%20diffused%20light%2C%20clean%20modern%20product%20photography%2C%20warm%20beige%20and%20sand%20tones%2C%20elegant%20tech%20lifestyle%20aesthetic%2C%20editorial%20gadget%20catalog%2C%20subtle%20reflections&width=800&height=600&seq=kakobuy-feat-tech-v2&orientation=landscape",
    },
    {
      title: "Kakobuy Accessories Spreadsheet",
      desc: "Dodatki i akcesoria — okulary, paski, biżuteria i nie tylko. Drobne elementy, które dopełniają styl.",
      icon: "ri-star-line",
      image: "https://readdy.ai/api/search-image?query=Elegant%20flatlay%20of%20premium%20accessories%20including%20tortoiseshell%20sunglasses%2C%20leather%20watch%2C%20and%20minimal%20bracelet%20on%20warm%20cream%20textured%20paper%2C%20soft%20natural%20morning%20light%2C%20editorial%20fashion%20product%20photography%2C%20warm%20earthy%20neutral%20tones%2C%20sophisticated%20catalog%20composition%2C%20gentle%20shadows&width=800&height=600&seq=kakobuy-feat-acc-v2&orientation=landscape",
    },
  ];

  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Popularne Arkusze Kakobuy
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Najczęściej wyszukiwane kategorie produktów — sprawdź, co jest teraz na topie
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all hover:border-accent-300/60 cursor-pointer"
            >
              <div className="w-full h-40 md:h-48 overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                    <i className={`${feature.icon} text-accent-500 text-xs`}></i>
                  </span>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900">
                    {feature.title}
                  </h3>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}